import axios from "axios";
import * as types from "./types";
import * as FileSaver from "file-saver";

export const fetchUseraction = (templateId,{ onSuccess, onFailure }) => {
  return function (dispatch) {
      axios.get(types.API_URL + `/admin/v1/disbursement/getUsers?templateId=${templateId}`)
          .then(function (response) {
              dispatch({
                  type: types.USERLIST_SUCCESS_ACTION,
                  payload: response.data
              });
              onSuccess(response.data)
          })
          .catch(function (error) {
              dispatch({
                  type: types.USERLIST_FAILURE_ACTION,
                  payload: error
              });
              onFailure()
          });
  };

}

export const adduser = (addUserData, { onSuccess, onFailure }) => {
  return function (dispatch) {
      console.log("Add User Data",addUserData)
      axios.post(types.API_URL + `/admin/v1/disbursement/addUsers`, addUserData)
          .then(function (response) {
              if (response.data.success == true) {
                  dispatch({
                      type: types.ADD_USER_SUCCESS_ACTION,
                      payload: response.data
                  });
              }
              onSuccess(response);
          })
          .catch(function (error) {
              dispatch({
                  type: types.ADD_USER_FAILURE_ACTION,
                  payload: error
              });
              onFailure(error)
          });
  };

}
export const EditUser = (editData ,{ onSuccess, onFailure }) => {
  return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/editUsers`, editData)
          .then(function (response) {
              dispatch({
                  type: types.EDIT_USER_SUCCESS_ACTION,
                  payload: response.data
              });
              onSuccess(response.data);
          })
          .catch(function (error) {
              dispatch({
                  type: types.EDIT_USER_FAILURE_ACTION,
                  payload: error
              });
              onFailure(error);
          });
  };

}
export const DeleteUser = (user_id, { onSuccess, onFailure }) => {
  return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/deleteDistributor?userId=${user_id}`,)
          .then(function (response) {
              dispatch({
                  type: types.DELETE_USER_SUCCESS_ACTION,
                  payload: response.data
              });
              onSuccess();
          })
          .catch(function (error) {
              dispatch({
                  type: types.DELETE_USER_FAILURE_ACTION,
                  payload: error
              });
              onFailure();
          });
  };

}

export const userdata = (email) => {
  console.log("USER DATA")
  return function (dispatch) {
    dispatch({
      type: types.SET_EMAIL,
      payload: email,
    });
  };
};

export const adminFileUpload = (file, fileName, { onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/uploadFile`,
          formData
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure(error);
        });
    };
  };

  export const distributorFileUpload = (file, fileName, templateName,selectedDist,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)
    formData.append("templateName",templateName)
    formData.append("selectedDist",selectedDist)
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/distributor/v1/disbursement/uploadFile`,
          formData
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const distributorSupportingFileUpload = (files, fileNames, templateName,selectedDist,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    console.log(files,'filesss')
    // Append each file and its corresponding name
    files.forEach((file, index) => {
        formData.append("files", file);  // The "files" key should be what your backend expects for multiple files
        formData.append("fileNames", fileNames);  // Make sure fileNames is an array matching the files
    });
    
    formData.append("templateName", templateName);
    formData.append("selectedDist",selectedDist)  // Assuming this applies to all files

    return function (dispatch) {
        axios
            .post(
                types.API_URL + `/distributor/v1/disbursement/uploadSupportingFile`,  // Adjust endpoint if necessary
                formData
            )
            .then(function (response) {
                dispatch({
                    type: types.UPLOAD_MASTER_FILE_SUCCESS,
                    payload: response.data,
                });
                onSuccess(response.data);
            })
            .catch(function (error) {
                dispatch({
                    type: types.UPLOAD_MASTER_FILE_FAILURE,
                    payload: error,
                });
                onFailure();
            });
    };
};


  export const saveUploadedfile = (fileData, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/saveFile`, fileData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.SAVE_UPLOADED_FILE_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.SAVE_UPLOADED_FILE_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }


  export const fetchTemplates = ({ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getTemplate`)
            .then(function (response) {
                dispatch({
                    type: types.GET_TEMPLATES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_TEMPLATES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  }

  export const fetchTemplatesById = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getTemplatebyId?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_TEMPLATES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_TEMPLATES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  }


  export const fetchMasterData = ({ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/home/getMaster`)
            .then(function (response) {
                dispatch({
                    type: types.GET_MASTER_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_MASTER_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const filterMasterData = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/home/filterMaster`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_FILTER_MASTER_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_FILTER_MASTER_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const saveUploadedMasterfile = (fileData, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/home/saveFile`, fileData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.SAVE_UPLOADED_MASTER_FILE_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.SAVE_UPLOADED_MASTER_FILE_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }


  export const fetchDashboardData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/dashboard?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_DASHBOARD_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DASHBOARD_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const deleteFileTemplate = (fileData, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/deleteFile`, fileData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.DELETE_FILE_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.DELETE_FILE_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  }

  export const updateFileName = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/updatefileName`, data)
        .then(function (response) {
          dispatch({
            type: types.UPDATE_FILE_NAME_SUCCESS_ACTION,
            payload: response.data
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPDATE_FILE_NAME_FAILURE_ACTION,
            payload: error
          });
          onFailure(error);
        });
    };
  }

  export const updateOneTimeUpload = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/updateOneTimeUpload`, data)
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error
          });
          onFailure(error);
        });
    };
  }

  export const bulkUpdateUsersDates = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/bulkUpdateUsersDates`, data)
        .then(function (response) {
          if (onSuccess) onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          if (onFailure) onFailure(error);
        });
    };
  }



  export const rawFileProcess = (file,fileName,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    if (file instanceof File || file instanceof Blob) {
      formData.append("file", file);
    }
    formData.append("fileName",fileName)
    formData.append("templateId",templateId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/rawfileProcess`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const wsQpsWorkingUpload = (file,fileName,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)
    formData.append("templateId",templateId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/uploadQPSWorkings`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const psrTargetRawFileProcess = (file,fileName,siteName,type,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    if (fileName == 'PSR'){
        formData.append("fileName","PSR Target")
    }
    else{
        formData.append("fileName",fileName)
    }
    
    formData.append("siteName",siteName)
    formData.append("type",type)
    formData.append("templateId",templateId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/rawfileProcess`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const fetchRawFilesData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        // Timestamp param busts browser/proxy caches so statuses are never stale
        axios.get(types.API_URL + `/admin/v1/disbursement/getRawFiles?templateId=${templateId}&_ts=${Date.now()}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_RAW_FILES_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const fetchAutomationStatusData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getAutomationStatus?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const runAutomationScript = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/automation/tool`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const sendFeedbackMail = (fileData, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/mailFeedback`, fileData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.SEND_FEEDBACK_MAIL_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.SEND_FEEDBACK_MAIL_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const downloadDisbursementReportAction = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/download/dashboard?templateId=${templateId}`, {
          responseType: "blob",
        })
        .then(function (response) {
          FileSaver.saveAs(response.data, `DisbursementTracker.xlsx`);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess();
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendVerificationCode = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/sendVerificationCode`, data)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.SEND_VERIFICATION_CODE_MAIL_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.SEND_VERIFICATION_CODE_MAIL_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const verifyVerificationCode = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/checkVerificationCode`, data)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.VERIFY_VERIFICATION_CODE_MAIL_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.VERIFY_VERIFICATION_CODE_MAIL_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }


  export const getDisbursementFormulas = ({onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/readFormulas`)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const updateDisbursementFormulas = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/updateFormulas`,data)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const deleteFileFromDistributorSide = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/deleteFileDistributor`,data)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_DELETE_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_DELETE_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const rollbackPairMasterUpload = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/distributor/v1/disbursement/home/rollbackFile`,data)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_DELETE_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_DELETE_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure(error);
        });
    };
  };

  export const fetchBranchMappingData = ({ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/branchMapping`)
            .then(function (response) {
                dispatch({
                    type: types.GET_DASHBOARD_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DASHBOARD_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const updateBranchMappingData = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/updateBranchMapping`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_DASHBOARD_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DASHBOARD_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const getWorkingFiles = (templateId,disType,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/downloadFiles?templateId=${templateId}&disType=${disType}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const getsplittedFiles = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getSplittedFiles?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getSiteWiseSplittedFiles = (loginId,tempId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getDistributorFiles?userId=${loginId}&templateId=${tempId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const dseFileUpload = (file,fileName,userId,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)  
    formData.append("userId",userId)
    formData.append("templateId",templateId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/uploadDseFiles`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const getSplitFilesFormulas = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/readSplitFormulas`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const updateSplitFileFormulas = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/updateSplitFormulas`,data)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const runLeapAutomation = ({onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/leapFileAutomation`)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const runSubDAutomation = ({onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/subDFileAutomation`)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const editCredentialsData = ({onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/updateCredentialsData`,{
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          console.log(response.data,'data')
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const updateCredentialsData = (data,{onSuccess,onFailure}) => {
    console.log(data,'data')
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/saveCredentialsData`,data,{
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          console.log(response.data,'data')
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };


  export const updateAutoRunStatus = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/updtateStatus`,data,{
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const processApprovedFiles = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/splitSiteWise?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const splitSitewiseProcess = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/siteWiseSplitting?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendWorkingFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/sendWorkingMail`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const processCreditNote = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/creditNoteProcess`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendCreditNoteFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/sendCreditNoteMail`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendWholesaleCreditNoteFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesale/sendCreditNoteMail`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendWholesaleQPSCreditNoteFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesaleQPS/sendCreditNoteMail`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const cloneMonthlyTemplateAction = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/cloneMonthlyTemplate`, data)
        .then(function (response) {
          dispatch({
            type: types.CLONE_MONTHLY_TEMPLATE_SUCCESS_ACTION,
            payload: response.data,
          });
          if (onSuccess) onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.CLONE_MONTHLY_TEMPLATE_FAILURE_ACTION,
            payload: error,
          });
          if (onFailure) onFailure(error);
        });
    };
  };

  export const importFileTemplatesAction = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/importFileTemplates`, data)
        .then(function (response) {
          dispatch({
            type: types.IMPORT_FILE_TEMPLATES_SUCCESS,
            payload: response.data,
          });
          if (onSuccess) onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.IMPORT_FILE_TEMPLATES_FAILURE,
            payload: error,
          });
          if (onFailure) onFailure(error);
        });
    };
  };

  export const userForceLogout = (userId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/forceLogout?userId=${userId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const runSmartspotAutomationScript = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/finalAutomation`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const splitLatIncentivesScript = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/lat/splitFiles`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getLatSplitFiles = (templateId, disType, { onSuccess, onFailure }) => {
    return function (dispatch) {
        const data = { templateId, disType };
        axios.post(types.API_URL + `/admin/v1/disbursement/lat/getSplitFiles`, data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const updateMailContent = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/lat/updateMegContent`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const sendLatWorkingFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/lat/sendWorkingFiles`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const updateDistInfo = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/lat/distMap`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getLatSplitStatus = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursment/lat/checkLatFileStatus`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };


  export const splitSmartspotfiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/smartspot/splitFiles`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getSmartspotSplitStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursment/smartspot/checkSmartspotSplitStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const updateSmartspotDistInfo = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/smartspot/distMap`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getSmartspotsplittedFiles = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/getSplitFiles?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const smartspotDseFileUpload = (file,fileName,userId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)  
    formData.append("userId",userId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/uploadDseFiles`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const smartspotSendWorkingFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/smartspot/sendWorkingMail`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const compareTemplateColumns = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/hotspot/compareTemplateColumns`, data)
          .then(function (response) {
            dispatch({
                type: types.COMPARE_TEMPLATE_COLUMNS_SUCCESS,
                payload: response.data
            });
            onSuccess(response.data);
          })
          .catch(function (error) {
              dispatch({
                  type: types.COMPARE_TEMPLATE_COLUMNS_FAILURE,
                  payload: error
              });
              onFailure(error);
          });
    };
  };

  export const getPreviousMonthTemplate = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios.get(types.API_URL + `/admin/v1/disbursement/hotspot/getPreviousMonthTemplate?templateId=${templateId}`)
          .then(function (response) {
            dispatch({
                type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
                payload: response.data
            });
            onSuccess(response.data);
          })
          .catch(function (error) {
              dispatch({
                  type: types.GET_RAW_FILES_DATA_FAILURE_ACTION,
                  payload: error
              });
              onFailure(error);
          });
    };
  };


  export const getHotspotSplitStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursment/hotspot/checkHotspotSplitStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const processSmartspotCreditNote = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/smartspot/processCreditNote`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendSmartspotCreditNoteFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/smartspot/sendcreditNoteFilesMail`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  


  export const psrCustomReportPivotData = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/psrPivotCustomReport`,data,{
          responseType: "blob",
        })
        .then(function (response) {
          FileSaver.saveAs(response.data, `PSRCustomReport.xlsx`);
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getPsrCustomeReportStatus = ({onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/psrcheckCustomreportStatus`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getPSRChannelList = (templateId, {onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/psrGetChannels`, {
          params: { templateId },
        })
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const psrUpdateChannels = (templateId, { onSuccess, onFailure }) => {
  return function () {
    axios
      .post(types.API_URL + `/admin/v1/disbursement/psrUpdateChannels`, {
        templateId,
      })
      .then(function (response) {
        if (onSuccess) onSuccess(response.data);
      })
      .catch(function (error) {
        console.log(error);
        if (onFailure) onFailure();
      });
  };
};

  export const runWholeSaleAutomationScript = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/wsFinalProcess`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getWholeSaleAutomationScriptStatus = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursment/wholesale/finalReportStatus?templateId=${templateId}`,)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getWholeSaleLocationsData = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/getDistDetails`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const addWholeSalePeriodsData = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/wholesale/addSalesPeriods`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getWholeSalePeriodsData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/wholesale/getSalesPeriods?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const wholesaleSplitFiles = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/wholesale/splitSiteWise`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const wholesaleQPSSplitFiles = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/wholesaleQPS/splitSiteWise`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getwholesalesplitStatus = (templateId,fileName,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/wholesale/getsplitStatus?templateId=${templateId}&fileName=${fileName}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getwholesalesplittedFiles = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/wholesale/getsplittedFiles?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getwholesaleqpssplittedFiles = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/wholesaleQPS/getsplittedFiles?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const wholesaleDseFileUpload = (file,fileName,userId,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)  
    formData.append("userId",userId)
    formData.append("templateId",templateId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/wholesale/uploadDseFiles`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const wholesaleQPSDseFileUpload = (file,fileName,userId,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)  
    formData.append("userId",userId)
    formData.append("templateId",templateId)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/wholesaleQPS/uploadDseFiles`, formData)
            .then(function (response) {
                if (response.data.success == true) {
                    dispatch({
                        type: types.RAW_FILE_PROCESS_SUCCESS_ACTION,
                        payload: response.data
                    });
                }
                onSuccess(response);
            })
            .catch(function (error) {
                dispatch({
                    type: types.RAW_FILE_PROCESS_FAILURE_ACTION,
                    payload: error
                });
                onFailure(error)
            });
    };
  
  }

  export const processCreditNoteWholeSale = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesale/processCreditNote`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const processCreditNoteWholeSaleQPS = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesaleQPS/processCreditNote`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getWholesalDisbursementFormulas = (type,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesale/readFormulas`,type)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const wholesaleIpdateDisbursementFormulas = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesale/updateFormulas`,data)
        .then(function (response) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendWholesaleWorkingFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesale/sendWorkingFiles`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendWholesaleQPSWorkingFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/wholesaleQPS/sendWorkingFiles`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const subdPiFinalWorkingFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/lat/subdpi/workingFile`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const subdPiFinalWorkingFilesStatus = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursment/lat/subdpi/getStatus`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getSubdpiLocationsData = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/lat/subdpi/getColumns`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getSubdpiPeriodsData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/subdpi/getSalesPeriods?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const addSubdPiPeriodsData = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/subdpi/addSalesPeriods`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getPlanData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/hotspot/downloadPlanData?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const checkHotspotInputsData = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/hotspot/checkInputs?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const extractHotspotTemplateCol = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        console.log('template id - extractHotspotTemplateCol - ', templateId)
        axios.get(types.API_URL + `/admin/v1/disbursement/hotspot/applyMappingCol?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }


  export const saveHotspotTemplateCol = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/hotspot/saveTemplateConditions`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getHotspotTemplateConditions = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/hotspot/getTemplateConditions?templateId=${templateId}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getDisbursementSummaryFormat = (templateId,dashboardType,{ onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getDisbursementSummaryFormat?templateId=${templateId}&type=${dashboardType}`)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const getDisbursementSummaryData = (data,{ onSuccess, onFailure }) => {
    console.log('data - getDisbursementSummaryData - ', data)
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/getDisbursementSummaryData`,data)
            .then(function (response) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION,
                    payload: response.data
                });
                onSuccess(response.data)
            })
            .catch(function (error) {
                dispatch({
                    type: types.GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION,
                    payload: error
                });
                onFailure()
            });
    };
  
  }

  export const summaryFileUpload = (file, fileName, templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)
    formData.append("templateId",templateId)
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/uploadTracker`,
          formData
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const summaryRemarksUpload = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/distributor/v1/disbursement/uploadSupportingRemarks`,
          data
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const updateFileUploadValidity = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/update/templateDates`,
          data
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const qpsInputUpload = (file, templateId,fileType,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("templateId",templateId)
    formData.append("fileType",fileType)
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/wholesale/qpsUploadFile`,
          formData
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getQpsProcessStatus = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/wholesale/qpsProcessStatus?templateId=${templateId}`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getQpsProcessFilesList = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/wholesale/getQPSFileList?templateId=${templateId}`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };


  export const dashboardFilesUpload = (file,fileName,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)
    formData.append("templateId",templateId)
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/dashboard/supportingFileUpload`,
          formData
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getSmartQPSConsoleFile = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/wholesale/getQpsConsoleFile?templateId=${templateId}`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getApprovedEmails = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/getApprovalEmailsData`,
          data
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getCreditNoteProcessStatus = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/getCreditNoteProcessStatus?templateId=${templateId}`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getWholesaleWokingReleaseProcessStatus = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/wholesale/checkProcessStatus?templateId=${templateId}`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getWholesaleQPSWokingReleaseProcessStatus = (templateId,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/wholesaleQPS/checkProcessStatus?templateId=${templateId}`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const downloadallDSEfiles = (templateId,disType,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/dse/download_zip?templateId=${templateId}&disType=${disType}`, {
          responseType: "blob",
        })
        .then(function (response) {
          FileSaver.saveAs(response.data, `${disType}_files.zip`);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess();
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };


  export const downloadallCreditNotefiles = (templateId,disType,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/creditNote/download_zip?templateId=${templateId}&disType=${disType}`, {
          responseType: "blob",
        })
        .then(function (response) {
          FileSaver.saveAs(response.data, `${disType}_files.zip`);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess();
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const sendApprovalEmailToPandG = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursment/sendApprovalEmail`,data
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };
   export const updateCustomerEmailIds = (data,{ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/customerEmailMappings`,data
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const FetchCustomerEmailIds = ({ onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(
          types.API_URL + `/admin/v1/disbursement/customerEmailMappings`
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const fetchRetailingPSR = (file,fileName,templateId,{ onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName",fileName)
    formData.append("templateId",templateId)
    return function (dispatch) {
      axios
        .post(
          types.API_URL + `/admin/v1/disbursement/extractionRetailing`,
          formData
        )
        .then(function (response) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_SUCCESS,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.UPLOAD_MASTER_FILE_FAILURE,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getRetailingExtractionStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/extractionRetailingStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getVisibilityReportStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/visibilityReportStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };
  
  export const vsismpworking = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/vcIsmpWorking`,data)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getVcISMpWorkingStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/vcIsmpStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getOneOffInputUploadStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/oneoffInputStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const oneOffFinalWorking = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/oneOffdisplayProcessing`,data)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getoneOffFinalWorkingStatus = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/oneOffFnalWorkingStatus?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const extractRetailingData = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/extractionRetailingfromPSR`,data)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };


  export const bulkDownloadDistFiles = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/buldDownload`,data, {
          responseType: "blob",
        })
        .then(function (response) {
          FileSaver.saveAs(response.data, `files.zip`);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess();
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getSupervisoryLatInputs = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/lat/supervisoryLAT/getInputs?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

    export const startSupervisoryLATProcess = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/lat/supervisoryLAT/startProcess`,data)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const getUpdatedTemplateName = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/fetchupdatedTemplates?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  
  export const checkSmartspotInputData = (templateId, auditTypeOrCallbacks, callbacks) => {
    let auditType = "Physical + Seller";
    let opts = callbacks;
    if (typeof auditTypeOrCallbacks === 'object' && auditTypeOrCallbacks !== null && (auditTypeOrCallbacks.onSuccess || auditTypeOrCallbacks.onFailure)) {
      opts = auditTypeOrCallbacks;
    } else if (typeof auditTypeOrCallbacks === 'string') {
      auditType = auditTypeOrCallbacks;
    }
    const { onSuccess, onFailure } = opts || {};
    return function (dispatch) {
      axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/checkInputs?templateId=${templateId}&auditType=${encodeURIComponent(auditType)}`)
      .then(
        res => {
          dispatch({ type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION, payload: res.data })
          if (onSuccess) onSuccess(res.data)
        }
      )
      .catch(err => { if (onFailure) onFailure(err) })
    }
  }

  export const checkSmartspotFinalReportInputs = (templateId, {onSuccess, onFailure}) => {
    return function (dispatch) {
      axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/checkSmartspotFinalReportInputs?templateId=${templateId}`)
      .then(res => { onSuccess(res.data) })
      .catch(err => { onFailure(err) })
    }
  }

  export const extractsmartspotTemplateCol = (templateId, sheetName, {onSuccess, onFailure}) => {
    return function (dispatch) {
      axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/applyMappingColPhase2?templateId=${templateId}&sheetName=${encodeURIComponent(sheetName)}`)
      .then(res => { onSuccess(res.data) })
      .catch(err => { onFailure(err) })
    }
  }

  export const savesmartspotTemplateCol = (data, {onSuccess, onFailure}) => {
    return function (dispatch) {
      axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/savePhase2TemplateConditions`, data)
      .then(res => { onSuccess(res.data) })
      .catch(err => { onFailure(err) })
    }
  }

  export const getSmartspotPlanData = (templateId, {onSuccess, onFailure}) => {
    return function (dispatch) {
      axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/downloadPlanData?templateId=${templateId}`)
      .then(
        res => {dispatch({
          type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
          payload: res.data
        })
        onSuccess(res.data)
      })
      .catch(err => onFailure(err))
    }
  }

  export const getSmartspotPreviousMonthTemplate = (templateId, templateKeyOrCallbacks, callbacks) => {
    let templateKey = "smartspotStandaloneTemplate";
    let opts = callbacks;
    if (typeof templateKeyOrCallbacks === 'object' && templateKeyOrCallbacks !== null && (templateKeyOrCallbacks.onSuccess || templateKeyOrCallbacks.onFailure)) {
      opts = templateKeyOrCallbacks;
    } else if (typeof templateKeyOrCallbacks === 'string') {
      templateKey = templateKeyOrCallbacks;
    }
    const { onSuccess, onFailure } = opts || {};
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/getPreviousMonthTemplate?templateId=${templateId}&templateKey=${encodeURIComponent(templateKey)}`)
            .then(res => { if (onSuccess) onSuccess(res.data) })
            .catch(err => { if (onFailure) onFailure(err) })
    }
}

export const compareSmartspotTemplateColumns = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/compareTemplateColumns`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const extractSmartspotTemplateCol = (templateId, templateKeyOrCallbacks, callbacks) => {
    let templateKey = "smartspotStandaloneTemplate";
    let opts = callbacks;
    if (typeof templateKeyOrCallbacks === 'object' && templateKeyOrCallbacks !== null && (templateKeyOrCallbacks.onSuccess || templateKeyOrCallbacks.onFailure)) {
      opts = templateKeyOrCallbacks;
    } else if (typeof templateKeyOrCallbacks === 'string') {
      templateKey = templateKeyOrCallbacks;
    }
    const { onSuccess, onFailure } = opts || {};
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/applyMappingCol?templateId=${templateId}&templateKey=${encodeURIComponent(templateKey)}`)
            .then(res => { if (onSuccess) onSuccess(res.data) })
            .catch(err => { if (onFailure) onFailure(err) })
    }
}

export const saveSmartspotTemplateCol = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/saveTemplateConditions`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const getSmartspotTemplateConditions = (templateId, templateKeyOrCallbacks, callbacks) => {
    let templateKey = "smartspotStandaloneTemplate";
    let opts = callbacks;
    if (typeof templateKeyOrCallbacks === 'object' && templateKeyOrCallbacks !== null && (templateKeyOrCallbacks.onSuccess || templateKeyOrCallbacks.onFailure)) {
      opts = templateKeyOrCallbacks;
    } else if (typeof templateKeyOrCallbacks === 'string') {
      templateKey = templateKeyOrCallbacks;
    }
    const { onSuccess, onFailure } = opts || {};
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/getTemplateConditions?templateId=${templateId}&templateKey=${encodeURIComponent(templateKey)}`)
            .then(res => { if (onSuccess) onSuccess(res.data) })
            .catch(err => { if (onFailure) onFailure(err) })
    }
}

export const getsmartspotTemplateConditions = (templateId, sheetName, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/getPhase2TemplateConditions?templateId=${templateId}&sheetName=${encodeURIComponent(sheetName)}`)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const runSmartspotFinalReportAutomationScript = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/phase2Automation`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const fetchSmartspotFinalReportAutomationStatus = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smartspot/phase2AutomationStatus?templateId=${templateId}`)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const clearSmartspotFinalReportFailedStatus = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smartspot/clearPhase2FailedStatus`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}
  
  
  
  


  
  

export const uploadSBDInputFile = (file, fileKey, templateId, { onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileKey);
    formData.append("templateId", templateId);
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/uploadSBDInputFiles`, formData)
            .then(function (response) {
                onSuccess(response.data);
            })
            .catch(function (error) {
                onFailure(error);
            });
    };
};

export const getSBDInputFiles = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getSBDInputFiles?templateId=${templateId}`)
            .then(function (response) {
                onSuccess(response.data);
            })
            .catch(function (error) {
                onFailure(error);
            });
    };
};

export const uploadSmallChannelInputFile = (file, fileKey, templateId, { onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileKey);
    formData.append("templateId", templateId);
    formData.append("process", "Small Channel");
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/uploadSBDInputFiles`, formData)
            .then(function (response) {
                onSuccess(response.data);
            })
            .catch(function (error) {
                onFailure(error);
            });
    };
};

export const getSmallChannelInputFiles = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getSBDInputFiles?templateId=${templateId}&process=Small Channel`)
            .then(function (response) {
                onSuccess(response.data);
            })
            .catch(function (error) {
                onFailure(error);
            });
    };
};


 export const startSBDClusterLATProcess = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/lat/sbdCluster/startProcess`,data)
        .then(function (response) {
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  }

  export const downloadSelectedFiles = (filesData, folderName, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/downloadFilesZip`, {
          files: filesData,
          folderName: folderName
        }, {
          responseType: 'blob'
        })
        .then(function (response) {
          FileSaver.saveAs(response.data, `${folderName}.zip`);
          dispatch({
            type: types.DOWNLOAD_SELECTED_FILES_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess();
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DOWNLOAD_SELECTED_FILES_FAILURE_ACTION,
            payload: error,
          });
          onFailure(error);
        });
    };
  };

  export const startBulkDownloadJob = (templateMonth, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/home/startBulkDownload`, {
          templateMonth: templateMonth,
          distributor: "All Distributors"
        })
        .then(function (response) {
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          onFailure(error);
        });
    };
  };

  export const pollBulkDownloadStatus = (jobId, { onSuccess, onFailure }) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/home/bulkDownloadStatus/${jobId}`)
        .then(function (response) {
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          onFailure(error);
        });
    };
  };
  

export const uploadISMPInputFile = (file, fileKey, templateId, { onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileKey);
    formData.append("templateId", templateId);
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/uploadISMPInputFiles`, formData)
            .then(function (response) { onSuccess(response.data); })
            .catch(function (error) { onFailure(error); });
    };
};

export const getISMPInputFiles = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getISMPInputFiles?templateId=${templateId}`)
            .then(function (response) { onSuccess(response.data); })
            .catch(function (error) { onFailure(error); });
    };
};

export const startISMPClusterLATProcess = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/lat/ismpCluster/startProcess`, data)
            .then(function (response) {
                dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
                onSuccess(response.data);
            })
            .catch(function (error) {
                dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
                onFailure();
            });
    };
};

// WS Distributor Support

export const uploadWSDistributorSupportFile = (file, fileKey, templateId, { onSuccess, onFailure }) => {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileKey);
    formData.append("templateId", templateId);
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/uploadWSDistributorSupportFiles`, formData)
            .then(function (response) { onSuccess(response.data); })
            .catch(function (error) { onFailure(error); });
    };
};

export const getWSDistributorSupportFiles = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/getWSDistributorSupportFiles?templateId=${templateId}`)
            .then(function (response) { onSuccess(response.data); })
            .catch(function (error) { onFailure(error); });
    };
};

export const startWSDistributorSupportProcess = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/lat/wsDistributorSupport/startProcess`, data)
            .then(function (response) {
                dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
                onSuccess(response.data);
            })
            .catch(function (error) {
                dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
              onFailure(error);
            });
    };
};


// OLAY APIS

export const olayWorkingApi = (data, method = "POST", { onSuccess, onFailure }) => {
  return function (dispatch) {
    const normalizedMethod = method.toLowerCase();
    const templateId = data && typeof data.get === "function" ? data.get("template_id") : data?.template_id;
    const query = normalizedMethod === "delete" && templateId ? `?template_id=${encodeURIComponent(templateId)}` : "";
    axios({
      method: normalizedMethod,
      url: types.API_URL + `/admin/v1/disbursement/olay/Olay-working${query}`,
      data,
    })
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};

export const olayInputTemplateApi = (data, method = "POST", { onSuccess, onFailure }) => {
  return function (dispatch) {
    const normalizedMethod = method.toLowerCase();
    const templateId = data && typeof data.get === "function" ? data.get("template_id") : data?.template_id;
    const query = normalizedMethod === "delete" && templateId ? `?template_id=${encodeURIComponent(templateId)}` : "";
    axios({
      method: normalizedMethod,
      url: types.API_URL + `/admin/v1/disbursement/olay/Olay-input-template${query}`,
      data,
    })
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};

export const olayStartProcessApi = (data, { onSuccess, onFailure }) => {
  return function (dispatch) {
    axios.post(types.API_URL + `/admin/v1/disbursement/olay/Olay-start-process`, data)
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};



export const getOlayFileApi = (templateId, { onSuccess, onFailure }) => {
  return function (dispatch) {
    const query = templateId ? `?template_id=${templateId}` : "";
    axios.get(types.API_URL + `/admin/v1/disbursement/olay/Get-olay-file${query}`)
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};

// GOLD RUSH APIS

export const getGoldRushDataApi = (templateId, { onSuccess, onFailure }) => {
  return function (dispatch) {
    const query = templateId ? `?template_id=${templateId}` : "";
    axios.get(types.API_URL + `/admin/v1/disbursement/gold/Get-gold-rush-data${query}`)
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};

export const goldRushStartProcessApi = (data, { onSuccess, onFailure }) => {
  return function (dispatch) {
    axios.post(types.API_URL + `/admin/v1/disbursement/gold/Gold-rush-start-process`, data)
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};

export const goldRushMappingApi = (data, method = "POST", { onSuccess, onFailure }) => {
  return function (dispatch) {
    const normalizedMethod = method.toLowerCase();
    const templateId = data && typeof data.get === "function" ? data.get("template_id") : data?.template_id;
    const query = normalizedMethod === "delete" && templateId ? `?template_id=${encodeURIComponent(templateId)}` : "";

    axios({
      method: normalizedMethod,
      url: types.API_URL + `/admin/v1/disbursement/gold/gold-rush-mapping${query}`,
      data,
    })
      .then(function (response) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION, payload: response.data });
        onSuccess(response.data);
      })
      .catch(function (error) {
        dispatch({ type: types.REPORT_DISBURSEMENT_DATA_FAILURE_ACTION, payload: error });
        onFailure(error);
      });
  };
};

// psr customized report downloads

export const psrCustomReportData = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/psrCustomReport`,data)
        .then(function (response) {
          // FileSaver.saveAs(response.data, `DisbursementTracker.xlsx`);
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          console.log(error);
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure();
        });
    };
  };

  export const psrCustomReportGeneration = (data,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .post(types.API_URL + `/admin/v1/disbursement/psrCustomReportdownload`,data)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure(error);
        });
    };
  };

  
  export const getPsrCustomReports = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/getpsrCustomReports?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure(error);
        });
    };
  };

  export const getPsrSiteName = (templateId,{onSuccess,onFailure}) => {
    return function (dispatch) {
      axios
        .get(types.API_URL + `/admin/v1/disbursement/getpsrSitename?templateId=${templateId}`)
        .then(function (response) {
          dispatch({
            type: types.GET_RAW_FILES_DATA_SUCCESS_ACTION,
            payload: response.data,
          });
          onSuccess(response.data);
        })
        .catch(function (error) {
          dispatch({
            type: types.DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION,
            payload: error,
          });
          onFailure(error);
        });
    };
  };


// ── Store Master / Seller Master Actions ──────────────────────────────────────

export const getSsmInputs = (templateId, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smsm/inputs?templateId=${templateId}`)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const getSsmDistributors = (templateId, process, templateName, { onSuccess, onFailure }) => {
    return function (dispatch) {
        let url = types.API_URL + `/admin/v1/disbursement/smsm/distributors?templateId=${templateId}&process=${process}`;
        // Add templateName query parameter if provided (for month-specific filtering)
        if (templateName && templateName.trim()) {
            url += `&templateName=${encodeURIComponent(templateName)}`;
        }
        axios.get(url)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const runsmsmAutomation = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/runAutomation`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const runSsmAllDistributors = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/runAllDistributors`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const getsmsmAutomationStatus = (templateId, distributor, location, process, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smsm/automationStatus?templateId=${templateId}&distributor=${encodeURIComponent(distributor)}&location=${encodeURIComponent(location)}&process=${process}`)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const getSsmOutputHistory = (templateId, distributor, location, process, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smsm/outputHistory?templateId=${templateId}&distributor=${encodeURIComponent(distributor)}&location=${encodeURIComponent(location)}&process=${process}`)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const downloadSsmAll = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/downloadAll`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const downloadSsmRowOutputs = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/downloadRowOutputs`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const uploadSsmDistributorFile = (file, fileName, templateId, distributor, location, process, { onSuccess, onFailure }) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);
    formData.append("templateId", templateId);
    formData.append("distributor", distributor);
    formData.append("location", location);
  formData.append("process", process);
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/uploadDistributorFile`, formData)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

    export const getSsmA8Status = (templateId, distributor, location, process, { onSuccess, onFailure }) => {
      return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smsm/a8/status?templateId=${templateId}&distributor=${encodeURIComponent(distributor)}&location=${encodeURIComponent(location)}&process=${process}`)
          .then(res => { onSuccess(res.data) })
          .catch(err => { onFailure(err) })
      }
    }

    export const createSsmA8File = (data, { onSuccess, onFailure }) => {
      return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/a8/createFile`, data)
          .then(res => { onSuccess(res.data) })
          .catch(err => { onFailure(err) })
      }
    }

export const setSsmA8CreateAllRunning = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/a8/setCreateAllRunning`, data)
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}

export const runSsmValidationConsole = (data, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.post(types.API_URL + `/admin/v1/disbursement/smsm/validationConsole`, data)
            .then(res => {
                if (res.data.queued && res.data.jobId) {
                    // Poll the status endpoint until completed or failed
                    const pollStatus = () => {
                        axios.get(types.API_URL + `/admin/v1/disbursement/smsm/validationConsole/status`, { params: { templateId: data.templateId, process: data.process } })
                            .then(statusRes => {
                                const status = statusRes.data.status;
                                if (status === 'completed') {
                                    onSuccess(statusRes.data);
                                } else if (status === 'failed') {
                                    onFailure({ response: { data: { error: statusRes.data.error || statusRes.data.message || 'Consolidation failed' } } });
                                } else {
                                    // Still running, poll again after 3 seconds
                                    setTimeout(pollStatus, 3000);
                                }
                            })
                            .catch(err => { onFailure(err) });
                    };
                    pollStatus();
                } else {
                    onSuccess(res.data);
                }
            })
            .catch(err => { onFailure(err) })
    }
}

export const downloadSsmValidationConsole = (params, { onSuccess, onFailure }) => {
    return function (dispatch) {
        axios.get(types.API_URL + `/admin/v1/disbursement/smsm/validationConsole/download`, { params })
            .then(res => { onSuccess(res.data) })
            .catch(err => { onFailure(err) })
    }
}
